import React, { useEffect, useState } from "react";
import { IconButton, Box, Typography, Button, SvgIcon } from "@mui/material";
import { RefreshCw, FileText, FileSpreadsheet } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../Redux/Store/Hooks";
import CommonTable2, {
  type Column,
} from "../../../.MODULS/BOOKLET_MODUL/Components/CommonTable/CommonTable2";
import { bookletRequestDecisionRead } from "../../../Redux/Slices/Booklet/Admin/BookletRequest/BookletRequestDecisionRead";
import { tutorsRead } from "../../../Redux/Slices/Booklet/Admin/Tutors/TutorsRead";
import { exportToExcel, exportToPDF } from "./BookletDownloader";
import { ReactComponent as PDFSVG } from "../../BOOKLET_MODUL/assets/images/pdf-svgrepo-com.svg";
import { ReactComponent as ExcelSVG } from "../../BOOKLET_MODUL/assets/images/icons8-excel.svg";

const BookletRequest: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const Selected_request = location.state?.request_id;

  const { data, isLoading } = useAppSelector(
    (state) => state.BookletRequestDecisionReadSlice
  );

  // ✅ Track selected filter
  const [statusFilter, setStatusFilter] = useState<
    "approved" | "pending" | "rejected"
  >("pending");

  useEffect(() => {
    if (Selected_request) {
      dispatch(bookletRequestDecisionRead({ req_ids: Selected_request }));
    } else {
      dispatch(bookletRequestDecisionRead({}));
    }
  }, [dispatch, Selected_request]);

  const columns: Column[] = [
    {
      field: "center_details",
      headerName: "Center Name",
      align: "center",
      sortable: true,
    },
    {
      field: "year_levels",
      headerName: "Year Group",
      align: "center",
      sortable: true,
    },
   {
  field: "class_details",
  headerName: "Class Details",
  align: "center",
  render: (row: any) => (
    <div
      style={{
        display: "inline-block",
        textAlign: "left",
      }}
    >
      {/* Subject always */}
      <div style={{ fontWeight: 500 }}>
        {row.subject_name || "-"}
      </div>

      {/* Day OR Custom Request */}
      {row.class_details !== null ? (
        <div style={{ fontSize: "13px", color: "#1976d2" }}>
          {row.class_details_day}
        </div>
      ) : (
        <div
          style={{
            marginTop: "4px",
            display: "inline-block",
            textAlign: "left",
            padding: "2px 8px",
            fontSize: "11px",
            borderRadius: "12px",
            backgroundColor: "#af50bf",
            color: "#ffffff",
            fontWeight: 500,
          }}
        >
          Custom Request
        </div>
      )}
    </div>
  ),
},
 {
      field: "tutor_details",
      headerName: "Tutor's Name",
      align: "center",
      sortable: true,
    },
    {
      field: "date",
      headerName: "Created Date",
      align: "center",
      sortable: true,
    },
    { field: "status", headerName: "Status", align: "center", sortable: true },
    {
      field: "printing_status",
      headerName: "Printing Status",
      align: "center",
      sortable: true,
    },
  ];

  const rows = (data?.data ?? [])
    .filter((item: any) => item.approval_status === statusFilter)
    .map((item: any) => {
      const createdDate = new Date(item.created_at);

      return {
        id: item.id,
        request_id: item.request_id,
        center_details: item.center_details?.[0]?.center_name,

        year_levels: Array.isArray(item.year_levels)
          ? Array.from(
              new Set(
                item.year_levels.map(
                  (y: { year_group?: { year_group?: string } }) =>
                    y.year_group?.year_group || "-"
                )
              )
            )
          : [],

        tutor_details: item.tutor_details?.name,
        subject_name: item.year_levels?.[0]?.subject_name,

        // ✅ Date → dd/mm/yyyy
        date: createdDate.toLocaleDateString("en-GB"),

        // // ✅ Day → Monday
        // day: createdDate.toLocaleDateString("en-US", {
        //   weekday: "long",
        // }),
 class_details: item.class_details,
         class_details_day: item.class_details?.day ||"-",

        printing_status:
          item.printing_status === "not_yet_started"
            ? "Not Yet Started"
            : item.printing_status === "in_progress"
            ? "In Progress"
            : item.printing_status === "completed"
            ? "Completed"
            : item.printing_status === "failed"
            ? "Failed"
            : "-",

        status:
          item.approval_status === "approved"
            ? "Request Approved"
            : item.approval_status === "rejected"
            ? "Request Rejected"
            : "Waiting for Approval",
      };
    });

  const allRows = (data?.data ?? []).map((item: any) => {
    const createdDate = new Date(item.created_at);

    return {
      id: item.id,
      request_id: item.request_id,

      center_details: item.center_details?.[0]?.center_name,

      year_levels: Array.isArray(item.year_levels)
        ? Array.from(
            new Set(
              item.year_levels.map(
                (y: { year_group?: { year_group?: string } }) =>
                  y.year_group?.year_group || "-"
              )
            )
          )
        : [],

      tutor_details: item.tutor_details?.name,

      // ✅ Class (Subject)
      subject_name: item.year_levels?.[0]?.subject_name || "-",

      // ✅ Date & Day
      date: createdDate.toLocaleDateString("en-GB"), // 15/12/2025
      // day: createdDate.toLocaleDateString("en-US", { weekday: "long" }), // Monday
       class_details: item.class_details,
         class_details_day: item.class_details?.day||"-",

      printing_status:
        item.printing_status === "not_yet_started"
          ? "Not Yet Started"
          : item.printing_status === "in_progress"
          ? "In Progress"
          : item.printing_status === "completed"
          ? "Completed"
          : item.printing_status === "failed"
          ? "Failed"
          : "-",

      status:
        item.approval_status === "approved"
          ? "Request Approved"
          : item.approval_status === "rejected"
          ? "Request Rejected"
          : "Waiting for Approval",
    };
  });

  const TableRows =
    Selected_request && Selected_request.length > 0 ? allRows : rows;

  console.log(TableRows, "TableRowsTableRows");

  return (
    <Box sx={{ p: 2 }}>
      {/* ---------- Header ---------- */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          Booklet Request
        </Typography>

        <Box sx={{ display: "flex", gap: 1 }}>
          <IconButton
            sx={{
              width: 40,
              height: 40,
              bgcolor: "#009DFF",
              "&:hover": {
                opacity: 0.8,
                bgcolor: "#009DFF",
              },
              borderRadius: 1,
              collor: "#ffffff",
            }}
            aria-label="Refresh"
            onClick={() => {
              dispatch(bookletRequestDecisionRead({}));
              dispatch(tutorsRead({ role: "TUTOR" }));
            }}
          >
            <RefreshCw size={20} color="#ffffff" />
          </IconButton>
          <IconButton
            sx={{
              width: 40,
              height: 40,
              bgcolor: "#009DFF",
              "&:hover": {
                opacity: 0.8,
                bgcolor: "#009DFF",
              },
              borderRadius: 1,
            }}
            color="error"
            aria-label="Export PDF"
            onClick={() => exportToPDF({ columns, rows: allRows })}
          >
            <SvgIcon
              sx={{ fontSize: "25px" }}
              component={PDFSVG}
              inheritViewBox
            />
          </IconButton>

          <IconButton
            sx={{
              width: 40,
              height: 40,
              bgcolor: "#009DFF",
              "&:hover": {
                opacity: 0.8,
                bgcolor: "#009DFF",
              },
              borderRadius: 1,
            }}
            aria-label="Export Excel"
            onClick={() => exportToExcel({ columns, rows: allRows })}
          >
            <SvgIcon
              sx={{ fontSize: "25px" }}
              component={ExcelSVG}
              inheritViewBox
            />
          </IconButton>
        </Box>
      </Box>

      {/* ---------- Status Filter Buttons ---------- */}
      {!Selected_request && (
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          {[
            { key: "pending", label: "Pending" },
            { key: "approved", label: "Approved" },
            { key: "rejected", label: "Rejected" },
          ].map((tab) => (
            <Button
              key={tab.key}
              onClick={() =>
                setStatusFilter(tab.key as "approved" | "pending" | "rejected")
              }
              sx={{
                fontSize: "12px",
                borderRadius: "8px",
                textTransform: "none",
                borderColor: "#009DFF",
                color: statusFilter === tab.key ? "#ffffff" : "#009DFF",
                bgcolor: statusFilter === tab.key ? "#009DFF" : "transparent",
                "&:hover": {
                  opacity: 0.8,
                  bgcolor: statusFilter === tab.key ? "#009DFF" : "transparent",
                },
              }}
              variant={statusFilter === tab.key ? "contained" : "outlined"}
            >
              {tab.label}
            </Button>
          ))}
        </Box>
      )}

      {/* ---------- Table ---------- */}
      <CommonTable2
        columns={columns}
        rows={TableRows}
        loading={isLoading}
        onRowClick={(row) =>
          navigate("/booklet_request/details", {
            state: { id: row.request_id },
          })
        }
      />
    </Box>
  );
};

export default BookletRequest;
